import logo from '@/assets/images/sciex/sciex_footer.png';
import styles from './index.module.scss';
export default () => {
  return (
    <div className={styles['footer']}>
      <div className={styles['content']}>
        <div className={styles['waper-logo']}>
          <img src={logo} />
        </div>
        <p>全国垂询电话：800 820 3488 （座机拨入） / 400 821 3897 （手机拨入）</p>
        <p>获取更多信息, 请访问 sciex.com.cn</p>
        <p>SCIEX官方微信：SCIEX-China</p>
      </div>
    </div>
  );
};
